// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_gk-0";